import { createQueryKeys } from '@lukemorales/query-key-factory';
import { environmentApi } from '../service';

export const environmentQueries = createQueryKeys('environment', {
  get: () => ({
    queryKey: ['get'],
    queryFn: () => environmentApi.environmentGet(),
  }),
});
